import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";

import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import "./PartnerProfile.css";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { CitySelect, CountrySelect, StateSelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { useMyContext } from "../../../components/Provider/CommonProvider";

const PartnerProfile = () => {
  const navigate = useNavigate();
const { themeMode, fetchRequest, globalImageUplaodAPI } = useMyContext(); // Access theme context
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState({});
  const [defaultData, setDefaultData] = useState({});

  const [editData, setEditData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [thumbnailImageFile, setThumbnailImageFile] = useState(null);
  const [countryid, setCountryid] = useState(0);
  const [stateid, setstateid] = useState(0);
  const [cityid, setCityid] = useState(0);
  const [passwordType, setPasswordType] = useState("password");
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };


  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const genderOptions = [
    { value: 'male', name: 'Male' },
    { value: 'female', name: 'Female' },
    { value: 'other', name: 'Other' }
  ];

  // Fetch profile data - now matches admin edit API structure
  const fetchProfileData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/partner/profile`,
        { headers }
      );

      if (response.data.status) {
        const data = response.data.data;
        const partnerUser = data.partnerUser;

        setProfileData(partnerUser);
        setEditData(partnerUser);

        // Store additional data from API response
        setDefaultData({
          roles: data.roles,
          countryCodes: data.countryCodes,
          signupConfig: data.signupConfig
        });

      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      toast.error(error.response?.data?.message || 'Failed to load profile data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  // Handle input changes - simplified for flat structure
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log('Input changed:', { name, value }); // Debug log

    setEditData(prev => {
      const updated = {
        ...prev,
        [name]: value
      };
      console.log('Updated editData:', updated); // Debug log
      if (name === "password") {
        setIsPasswordChanged(true);
      }
      return updated;
    });


    // Clear errors
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  };

  const handleWorld = (name, value) => {
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle image selection (global upload approach)
  const handleImageChange = async (event) => {
    const { files, name } = event.target;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif'];
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
    if (!files?.[0]) return;
    const selected = files[0];
    if (!allowedTypes.includes(selected.type)) {
      setErrors(prev => ({
        ...prev,
        [name]: 'Only JPG, JPEG, WEBP, PNG and GIF files are allowed.'
      }));
      if (name === "image") setProfileImageFile(null);
      if (name === "thumbnail") setThumbnailImageFile(null);
      return;
    }

    if (files?.length > 0) {
      if (name === "image") setProfileImageFile(selected);
      if (name === "thumbnail") setThumbnailImageFile(selected);
    }
  };

  const handleClearSelectFile = (value) => {
    if (value === 'image') setProfileImageFile(null);
    if (value === 'thumbnail') setThumbnailImageFile(null);
    setErrors(prev => ({
      ...prev,
      [value]: ''
    }));
  };

  // Upload image using global image upload API
  const handleImageUpload = async () => {
    // 1. Profile Image Upload
    if (profileImageFile && editData?.id) {
      try {
        const imageFormData = new FormData();
        imageFormData.append('id', editData.id);
        imageFormData.append('modelName', 'User');
        imageFormData.append('avatar', profileImageFile);
        imageFormData.append('imageFields[]', 'avatar');

        const res = await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), data: imageFormData });
        const newAvatarUrl = res?.data?.avatar || res?.avatar || res?.data?.data?.avatar;
        if (newAvatarUrl) {
          setProfileData(prev => ({ ...prev, avatar_url: newAvatarUrl }));
          setEditData(prev => ({ ...prev, avatar_url: newAvatarUrl }));
        }
      } catch (error) {
        console.error('Avatar upload failed', error);
        toast.error('Failed to update profile picture');
      }
    }

    // 2. Thumbnail Image Upload
    if (thumbnailImageFile && editData?.partner_id) {
      try {
        const thumbFormData = new FormData();
        thumbFormData.append('id', editData.partner_id);
        thumbFormData.append('modelName', 'Partner');
        thumbFormData.append('thumbnail_image', thumbnailImageFile);
        thumbFormData.append('imageFields[]', 'thumbnail_image');

        const res = await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), data: thumbFormData });
        const newThumbUrl = res?.data?.thumbnail_image || res?.thumbnail_image || res?.data?.data?.thumbnail_image;
        if (newThumbUrl) {
          setProfileData(prev => ({ ...prev, thumbnail_image_url: newThumbUrl }));
          setEditData(prev => ({ ...prev, thumbnail_image_url: newThumbUrl }));
        }
      } catch (error) {
        console.error('Thumbnail upload failed', error);
        toast.error('Failed to update thumbnail image');
      }
    }

    setProfileImageFile(null);
    setThumbnailImageFile(null);
  };

  // Form validation (optional - no mandatory fields)
  const validateForm = () => {
    const newErrors = {};

    // Optional validation - you can add specific validations here if needed
    // For now, all fields are optional for profile updates

    if (isPasswordChanged && editData?.password) {
      if (editData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters long.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // Update profile
  const handleUpdateProfile = async () => {
    if (!validateForm()) return;

    setShowOverlay(true);
    try {
      const updatePayload = {
        name: editData?.name,
        username: editData?.username,
        city: editData?.city,
        state: editData?.state,
        country: editData?.country,
        gender: editData?.gender,
        commission_percentage: editData?.commission_percentage,
        bank_name: editData?.bank_name,
        branch_name: editData?.branch_name,
        account_number: editData?.account_number,
        IFSC_Code: editData?.IFSC_Code,
        upi_id: editData?.upi_id,
        upi_mobile_number: editData?.upi_mobile_number,
        user_role: editData?.user_role
      };

      if (isPasswordChanged && editData?.password) {
        updatePayload.password = editData.password;
      }


      console.log('Update payload:', updatePayload); // Debug log
      console.log('Current editData:', editData); // Debug log

      const response = await axios.put(
        `${process.env.REACT_APP_Baseurl}/partner/profile`,
        updatePayload,
        { headers }
      );

      if (response.data.status) {
        await handleImageUpload();
        toast.success('Profile updated successfully!');
        // Update local state with the updated data instead of refetching
        setProfileData(prev => ({ ...prev, ...editData }));
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error(error.response?.data?.message || 'Failed to update profile');
    } finally {
      setShowOverlay(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Response_Processing />
      </div>
    );
  }

  return (
    <>
      {showOverlay && <Response_Processing />}

      <AdminBackNavigation path={-1} text="Back" />

      <div className="d-flex justify-content-between align-items-center mb-4">
        <MessageHeading text="Edit Partner Profile" />
        <button
          className="btn btn-primary theme-button-bg-color"
          onClick={handleUpdateProfile}
        >
          Update
        </button>
      </div>

      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Partner Information" />

            <MessageLabel text="Username" />
            <AdminCustomInput
              type="text"
              name="username"
              value={editData?.username || ''}
              onChange={handleInputChange}
              error={errors['username']}
              placeHolder="Enter username"
            />

            <MessageLabel text="Name" />
            <AdminCustomInput
              type="text"
              name="name"
              value={editData?.name || ''}
              onChange={handleInputChange}
              error={errors['name']}
              placeHolder="Enter name"
            />

            <MessageLabel text="Email" />
            <AdminCustomInput
              type="email"
              name="email"
              value={editData?.email || ''}
              error={errors['email']}
              placeHolder="Enter email address"
              readOnly
            />

            <MessageLabel text="Password" />
            <div className="position-relative">
              <AdminCustomInput
                type={passwordType}
                name="password"
                value={editData?.password || ''}
                onChange={handleInputChange}
                error={errors['password']}
                placeHolder="Enter new password (leave blank to keep current)"
              />
              <div
                className="position-absolute"
                style={{
                  top: "10px",
                  right: "15px",
                  cursor: "pointer",
                  fontSize: "20px",
                }}
                onClick={togglePassword}
              >
                {passwordType === "password" ? <TbEyeClosed /> : <VscEye />}
              </div>
            </div>


            <MessageLabel text="Mobile Number" />
            <div className="row">
              <div className="col-4">
                <AdminCustomSelect
                  name="ccode"
                  value={editData?.ccode || ''}
                  options={defaultData?.countryCodes?.map((item) => ({
                    value: `+${item?.phonecode}`,
                    name: `${item?.country_name} (+${item?.phonecode})`
                  })) || [
                      { value: '+91', name: 'India (+91)' },
                      { value: '+1', name: 'US (+1)' },
                      { value: '+44', name: 'UK (+44)' }
                    ]}
                  defaultOptionName="Select Country"
                  disabled
                />
              </div>
              <div className="col-8">
                <AdminCustomInput
                  type="text"
                  name="mobile"
                  value={editData?.mobile || ''}
                  error={errors['mobile']}
                  placeHolder="Enter mobile number"
                  readOnly
                />
              </div>
            </div>

            <MessageLabel text="Gender" />
            <AdminCustomSelect
              name="gender"
              value={editData?.gender || ''}
              onChange={handleInputChange}
              options={genderOptions}
              defaultOptionName="Select gender"
            />

            <MessageLabel text="Commission Percentage" />
            <AdminCustomInput
              type="number"
              name="commission_percentage"
              value={editData?.commission_percentage || ''}
              onChange={handleInputChange}
              error={errors['commission_percentage']}
              placeHolder="Enter commission percentage"
            />
          </Wrapper>

          <Wrapper>
            <MessageHeading text="Bank Details" />

            <MessageLabel text="Bank Name" />
            <AdminCustomInput
              type="text"
              name="bank_name"
              value={editData?.bank_name || ''}
              onChange={handleInputChange}
              placeHolder="Enter bank name"
            />

            <MessageLabel text="Branch Name" />
            <AdminCustomInput
              type="text"
              name="branch_name"
              value={editData?.branch_name || ''}
              onChange={handleInputChange}
              placeHolder="Enter branch name"
            />

            <MessageLabel text="Account Number" />
            <AdminCustomInput
              type="text"
              name="account_number"
              value={editData?.account_number || ''}
              onChange={handleInputChange}
              placeHolder="Enter account number"
            />

            <MessageLabel text="IFSC Code" />
            <AdminCustomInput
              type="text"
              name="IFSC_Code"
              value={editData?.IFSC_Code || ''}
              onChange={handleInputChange}
              placeHolder="Enter IFSC code"
            />

            <MessageLabel text="UPI ID" />
            <AdminCustomInput
              type="text"
              name="upi_id"
              value={editData?.upi_id || ''}
              onChange={handleInputChange}
              placeHolder="Enter UPI ID"
            />

            <MessageLabel text="UPI Mobile Number" />
            <AdminCustomInput
              type="text"
              name="upi_mobile_number"
              value={editData?.upi_mobile_number || ''}
              onChange={handleInputChange}
              placeHolder="Enter UPI mobile number"
            />
          </Wrapper>

        </LeftWrapper>

        <RightWrapper>
          <Wrapper className="text-center">
            <MessageHeading text="Profile Image" />

            <AdminImageUploadZone
              onChange={handleImageChange}
              selectedFile={profileImageFile}
              uploadedImage={editData?.avatar_url}
              onDelete={() => handleClearSelectFile('image')}
              name="image"
              id={editData?.id}
              accept="image/jpeg,image/png,image/jpg,image/webp,image/gif"
              error={errors['image']}
            />
          </Wrapper>

          <Wrapper className="text-center">
            <MessageHeading text="Thumbnail Image" />

            <AdminImageUploadZone
              onChange={handleImageChange}
              selectedFile={thumbnailImageFile}
              uploadedImage={editData?.thumbnail_image_url}
              onDelete={() => handleClearSelectFile('thumbnail')}
              name="thumbnail"
              id={editData?.partner_id}
              accept="image/jpeg,image/png,image/jpg,image/webp,image/gif"
              error={errors['thumbnail']}
            />
          </Wrapper>

          <Wrapper>
            <MessageHeading text="Region" />

            <MessageLabel text="Country" />
            <CountrySelect
              id="country-select"
              onChange={(e) => {
                setCountryid(e.id);
                handleWorld('country', e.name);
              }}
              defaultValue={editData?.country ? { name: editData.country } : null}
              placeHolder="Select Country"
              inputClassName="bg-transparent theme-border-color theme-text-color border-0 country-input"
              containerClassName="custom-country"
            />

            <MessageLabel text="State" />
            <StateSelect
              id="state-select"
              key={`${countryid}-${editData?.state || ''}`}
              countryid={countryid}
              onChange={(e) => {
                setstateid(e.id);
                handleWorld('state', e.name);
              }}
              defaultValue={editData?.state ? { name: editData.state } : undefined}
              placeHolder="Select State"
              inputClassName="bg-transparent theme-text-color border-0 country-input"
              containerClassName="custom-country"
            />

            <MessageLabel text="City" />
            <CitySelect
              id="city-select"
              key={`${countryid}-${stateid}-${editData?.city || ''}`}
              countryid={countryid}
              stateid={stateid}
              onChange={(e) => {
                setCityid(e.id);
                handleWorld('city', e.name);
              }}
              defaultValue={editData?.city ? { name: editData.city } : undefined}
              placeHolder="Select City"
              inputClassName="bg-transparent theme-text-color border-0 country-input"
              containerClassName="custom-country"
            />
          </Wrapper>

          <Wrapper>
            <MessageHeading text="Role" />

            <MessageLabel text="Partner Role" />
            <AdminCustomSelect
              name="user_role"
              value={editData?.user_role || ''}
              onChange={handleInputChange}
              options={defaultData?.roles ? [
                {
                  value: defaultData.roles.id,
                  name: defaultData.roles.role_name
                }
              ] : []}
              defaultOptionName="Select role"
            />
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
};

export default PartnerProfile;
